var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { GET_USER_DATA, GET_USER_DATA_SUCCESS, GET_USER_DATA_ERROR, UPDATE_USER_SUBSCRIPTIONS, UPDATE_USER_SUBSCRIPTIONS_SUCCESS, UPDATE_USER_SUBSCRIPTIONS_ERROR, LOG_OUT } from "../constants/actionTypes";

var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case UPDATE_USER_SUBSCRIPTIONS:
    case GET_USER_DATA:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    case GET_USER_DATA_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: action.payload
        });
      }

    case UPDATE_USER_SUBSCRIPTIONS_SUCCESS:
      {
        return _extends({}, state, {
          data: _extends({}, state.data, {
            subscriptions: action.payload
          })
        });
      }

    case UPDATE_USER_SUBSCRIPTIONS_ERROR:
    case GET_USER_DATA_ERROR:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    case LOG_OUT:
      {
        return _extends({}, state, {
          data: null
        });
      }

    default:
      {
        return state;
      }
  }
});


// WEBPACK FOOTER //
// ./src/reducers/user.js